import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { map, switchMap } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AccountService, NoPropsError } from '../account';
import { PropService } from '../prop/prop.service';

function getCurrentPropId(accountService: AccountService, propService: PropService) {
  return accountService.getProfile().pipe(
    map(profile => {
      if (profile.props.length === 0) {
        throw new NoPropsError()
      }
      if (!propService.currentProp) {
        throw new Error('No prop selected')
      }
      return propService.currentProp.id
    })
  )
}

export const propInterceptor: HttpInterceptorFn = (req, next) => {
  const apiPropPrefix = environment.api.url.replace(/\/$/, '') + '/prop/'

  if (!req.url.startsWith(apiPropPrefix)) {
    return next(req)
  }

  const accountService = inject(AccountService)
  const propService = inject(PropService)

  return getCurrentPropId(accountService, propService).pipe(
    switchMap(propId => next(req.clone({
      params: req.params.set('prop_id', propId)
    })))
  )
}
